import { ActionType, ChangeMediaType, ContentType, EventType, IEventVoiceList, MissionType, ToolBarItemType } from '@/const/mission';
import { IEvents } from '@/interface';
import { ThumbnailType } from '@/interface/media';

import BgmItem from './bgm';
import BotItem from './bot';
import CharacterItem from './character';
import ImageItem from './image';
import PropsItem from './props';
import SpineItem from './spine';
import VideoItem from './video';

interface IProps {
  value: IEvents;
  arrayValue: IEvents[];
  disabled: boolean;
  botList: { name: string, id: string, url: string }[];
  voiceList: IEventVoiceList[];
  propsList: { name: string, id: string }[];
  sceneId?: string;
  index: number;
  fieldname: string;
  showSystem: boolean,
  missionType?: MissionType;
  isMergeSceneMission: boolean | undefined
  isHorizontal?: boolean;
  contentEventIdColWidth: number | undefined;
  thumbnail?: ThumbnailType; // 最近的上一张背景图 (视频)
  onChange: (value: any) => void;
  onEnter: (value: IEvents) => void;
}

const ItemComp: React.FC<IProps> = (props) => {
  const { value, contentEventIdColWidth } = props;
  const { type } = value;

  const getTabType = () => {
    if (type === EventType.EVENT_TYPE_EXCL) {
      return ToolBarItemType.ADD_DRAWER;
    }
    if (type === EventType.EVENT_TYPE_MESSAGE) {
      if (value?.message?.type === ContentType.CONTENT_TYPE_TEXT) {
        return ToolBarItemType.BOT_TEXT;
      }
    } else if (type === EventType.EVENT_TYPE_ACTION) {
      if (value.action?.type === ActionType.ACTION_TYPE_GUIDEREPLY) {
        return ToolBarItemType.ADD_GUIDE_REPLAY;
      }
      if (value?.action?.type === ActionType.ACTION_TYPE_SHOWCARD) {
        return ToolBarItemType.SHOW_ITEM;
      }
      if (value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE) {
        return ToolBarItemType.CHANGE_FORE_IMAGE;
      }
      if (value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE) {
        return ToolBarItemType.CHANGE_BG_IMAGE;
      }
      if (value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_BGM_AUDIO
        || value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_SOUND_EFFECT) {
        return ToolBarItemType.CHANGE_BGM_AUDIO;
      }
      if (value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_FULL_VIDEO
        || value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_VIDEO) {
        return ToolBarItemType.CHANGE_VIDEO;
      }
      if (value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE) {
        return ToolBarItemType.ADD_SPINE_FORE_IMAGE;
      }
      if (value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER) {
        return ToolBarItemType.ADD_MULTI_CHARACTER;
      }
    }
    return ToolBarItemType.SYSTEM_TEXT;
  };

  const itemType = getTabType();

  return (
    <div>
      {itemType === ToolBarItemType.SYSTEM_TEXT || itemType === ToolBarItemType.BOT_TEXT
        ? <BotItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}

      {itemType === ToolBarItemType.CHANGE_FORE_IMAGE
        ? <ImageItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}

      {itemType === ToolBarItemType.CHANGE_BG_IMAGE
        ? <ImageItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}

      {itemType === ToolBarItemType.CHANGE_BGM_AUDIO
        ? <BgmItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}

      {itemType === ToolBarItemType.CHANGE_VIDEO
        ? <VideoItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}

      {itemType === ToolBarItemType.SHOW_ITEM
        ? <PropsItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}

      {itemType === ToolBarItemType.ADD_SPINE_FORE_IMAGE
        ? <SpineItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}

      {itemType === ToolBarItemType.ADD_MULTI_CHARACTER
        ? <CharacterItem  {...props} contentEventIdColWidth={contentEventIdColWidth} /> : null}
    </div>
  );
};

export default ItemComp;
